import { createContext, useContext } from "react";
import { useSelector } from "react-redux";

const AuthContext = createContext();

export const useAuthContext = () => useContext(AuthContext);

function AuthProvider({ children }) {
  const user = useSelector((state) => state.user.user);
  return <AuthContext.Provider value={user}>{children}</AuthContext.Provider>;
}

export default AuthProvider;
